import { BasicRequest } from "./basicRequest";

export class EnablePremierServiceProductRequest extends BasicRequest{

    public premierServiceProductId!:number;
    public enable:boolean = false;

    constructor(){
        super();
    }
}